import React from 'react';
import { styled } from 'linaria/react';
import { PageOf } from './PageOf';
export const SearchMetaWrapper = /*#__PURE__*/styled('aside')({
  name: "SearchMetaWrapper",
  class: "s5sxyu6"
});

class SearchMeta extends React.PureComponent {
  render() {
    const {
      total,
      page,
      pages,
      className = ''
    } = this.props;
    return React.createElement(SearchMetaWrapper, {
      className: className
    }, React.createElement("header", null, total, " items"), React.createElement(PageOf, {
      page: page,
      pages: pages
    }));
  }

}

export default SearchMeta;

require("../../../../../.linaria-cache/node_modules/@jetshop/ui/Search/SearchPage/SearchMeta.linaria.css");